exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-button--text[data-v-bbbefb3a] {\n  padding: 0 !important;\n  width: auto !important;\n  margin-left: 5px !important;\n}\n.el-button--text span[data-v-bbbefb3a] {\n  margin-left: 0px !important;\n}\n", ""]);

// exports
